var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_2141)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 73.5,
    r: 62.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.8044 81.6607H83.445M99.687 72.3795V67.739C99.687 66.5082 99.1981 65.3279 98.3278 64.4576C97.4575 63.5873 96.2772 63.0984 95.0464 63.0984H48.6406C47.4098 63.0984 46.2295 63.5873 45.3592 64.4576C44.4889 65.3279 44 66.5082 44 67.739V95.5825C44 96.8132 44.4889 97.9936 45.3592 98.8638C46.2295 99.7341 47.4098 100.223 48.6406 100.223H95.0464C96.2772 100.223 97.4575 99.7341 98.3278 98.8638C99.1981 97.9936 99.687 96.8132 99.687 95.5825V90.9419V72.3795ZM99.687 72.3795H81.1247C78.6631 72.3795 76.3024 73.3574 74.5619 75.0979C72.8213 76.8385 71.8435 79.1992 71.8435 81.6607C71.8435 84.1222 72.8213 86.4829 74.5619 88.2235C76.3024 89.964 78.6631 90.9419 81.1247 90.9419H99.687V72.3795ZM99.687 72.3795C102.149 72.3795 104.509 73.3574 106.25 75.0979C107.99 76.8385 108.968 79.1992 108.968 81.6607C108.968 84.1222 107.99 86.4829 106.25 88.2235C104.509 89.964 102.149 90.9419 99.687 90.9419V72.3795ZM57.9217 63.0984V49.1766C57.9217 45.4844 59.3885 41.9433 61.9993 39.3325C64.6102 36.7216 68.1512 35.2549 71.8435 35.2549C75.5358 35.2549 79.0768 36.7216 81.6877 39.3325C84.2985 41.9433 85.7652 45.4844 85.7652 49.1766V63.0984H57.9217ZM97.3667 81.6607H102.007H97.3667ZM88.0855 81.6607H92.7261H88.0855Z",
    stroke: "#3EBF0F",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_2141",
    x: 0.464968,
    y: 0.649681,
    width: 152.07,
    height: 152.07,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.18471
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.76752
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.136774 0 0 0 0 0.433333 0 0 0 0 0.0287248 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_2141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_2141",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.e81297cd20801605e9913a8c7c2111ff.svg";
export { ForwardRef as ReactComponent };